export class UserBO {
  id: string;
  firstName: string;
  lastName: string;
  middleName: string;
  email: string;
  phone1: string;
  phone2: string;
  statusLid: string;
  loginUserId: string | null;
  agencyId: string | null;
  username: string;
  password: string;
  roleName: string[];
  statusLname: string;
  userRole: string;
  userRoleId: string;
  isBlocked: boolean;
  isAgencyAdmin: boolean;
  excludeIprestric: boolean;
  locationIdList: LocationIdBO[];
  locId: string[];
  userLocation: string;
  roleList:any[]=[]
}
export class DropList {
  label: string;
  value: string;
}

export class DropList1 {
  value: string;
  key: string;
}

export class sortingObj {
  itemperpage: number = 20;
  currentPgNo: number = 1;
  shortcolumn: string = "Fname";
  shortType: string = 'asc';
}

export class functionpermission {
  usercreate: boolean = true;
  userupdate: boolean = true;
  userkeyupdate: boolean = true;
}

export class WhereCondition {
  field: string = "Fname";
  value: string = "";
  operator: string = "startswith";
  orderNo: number = 1;
  predicate: string = "and";
  type: string = "string";
  matchCase: boolean = false;
}
export class GetUserListBo {
  orderColumn: string = "name";
  orderType: string = "asc";
  pageitem: number = 10;
  currentpageno: number = 1;
  userId: string = "00000000-0000-0000-0000-000000000000";
  field: string = "name";
  value: string = "";
  matchCase: boolean = false;
  operator: string = "startswith";
  type: string = "string";
  // agencyId: string | null = "00000000-0000-0000-0000-000000000000";
}
export class columnWidth {
  column: string = "";
  width: number = 0;
}

export class ColumnChangeBO {
  id: string = "00000000-0000-0000-0000-000000000000";
  userid: string = "00000000-0000-0000-0000-000000000000";
  agencyId: string = "00000000-0000-0000-0000-000000000000";
  column: string;
}

export class ChangePasswordRequestBO {
  oldPassword: string;
  newPassword: string;
}
export class LocationIdBO {
  locationId: string;
}
